module.exports = __webpack_public_path__ + "54e9c49daf63aa80a52a7dd5dbc6ff60.png";